module.exports = __webpack_public_path__ + "assets/img/LTC044.f9ffc9ca.gif";